<template>
  <v-card v-if="canRead">
    <UserBadge :have-permissions="!isSubDisabled"/>
    <v-card-title>
      {{ $t('settings.dids.title')}}&nbsp;
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="dids"
        :no-data-text="$t('settings.dids.table.noData')">
        <template v-slot:[`item.did`]="{ item }">
          {{ item.did | formatPhoneNum(countryCode) }}
        </template>
        <template v-slot:[`item.sms_capable`]="{ item }">
          <v-icon v-if="item.sms_capable" color="success">mdi-check</v-icon>
          <b v-if="item.default_sms_did" class="green--text">{{ $t('settings.dids.default') }}</b>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import UserBadge from './user_badge'

export default {
  name: 'settings-dids',
  components: { UserBadge },
  computed: {
    ...mapGetters({
      canRead: 'permissions/didsRead',
      dids: 'settings/dids',
      users: 'users/listAll',
      countryCode: 'countryCode',
      activeSubAccount: 'settings/activeSubAccount',
      isOwnerCurUser: 'settings/isOwnerCurUser'
    }),
    headers () {
      return [
        { text: this.$t('settings.dids.table.name'), value: 'name' },
        { text: this.$t('settings.dids.table.did'), value: 'did' },
        { text: this.$t('settings.dids.table.destType'), value: 'dest_type' },
        { text: this.$t('settings.dids.table.destName'), value: 'target' },
        { text: this.$t('settings.dids.table.smsCapable'), value: 'sms_capable' }
      ]
    },
    isSubDisabled: function () {
      if (!this.activeSubAccount || this.isOwnerCurUser) {
        return false
      }
      return !this.activeSubAccount.features?.includes('dids')
    }
  }
}
</script>

<style scoped>
</style>
